// Translations
import landing from '../views/landing/translations/de'

// Translation: Error (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
